import { render, staticRenderFns } from "./Wp_jd_order_flow.vue?vue&type=template&id=65b74f32&scoped=true&"
import script from "./Wp_jd_order_flow.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_order_flow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b74f32",
  null
  
)

export default component.exports